import Swiper, { Pagination } from "swiper";

export function blockRealisationsSlider() {
  new Swiper(".realisations-slider__swiper", {
    modules: [Pagination],
    direction: "horizontal",
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
      },
      1025: {
        slidesPerView: 4,
      },
    },
  });
}
